module.exports = __webpack_public_path__ + "img/R_HAZ.20705063.svg";